import React from 'react'
import PropTypes from 'prop-types'
import { TEST_LIBRARY_TABS } from '../../utils/pdlBulkUploadHandoff'
import { StyledTabs, TabPane } from './styled'

const TestLibraryTabs = ({ activeTab, onChange }) => (
  <StyledTabs activeKey={activeTab} onChange={onChange}>
    <TabPane
      tab={<span data-cy="testLibraryTabMyContent">Created by Me</span>}
      key={TEST_LIBRARY_TABS.MY_CONTENT}
    />
    <TabPane
      tab={
        <span data-cy="testLibraryTabReadyToReview">
          Pending Review (Imported)
        </span>
      }
      key={TEST_LIBRARY_TABS.READY_TO_REVIEW}
    />
  </StyledTabs>
)

TestLibraryTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TestLibraryTabs
